import dayjs from 'dayjs'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import type { ComponentProps, ReactNode } from 'react'
import { Button } from './Button'
import ButtonGroup from './ButtonGroup'
import CalendarioMensal from './CalendarioMensal'
import GridToolbarContainer from './DataGrid/components/CustomGridToolBar/Container'
import Skeleton from './Skeleton'
import { Label } from './ui/label'

type Props = ComponentProps<typeof CalendarioMensal> & {
    onCompetenciaChange: (competencia: string) => void
    /** Ações à direita da toolbar, como o botão de adicionar. */
    acoes?: ReactNode
    loading?: boolean
}

/** {@link CalendarioMensal} com toolbar para trocar de mês. */
export default function CalendarioCompetencia({
    competencia,
    onCompetenciaChange,
    acoes,
    loading = false,
    ...calendarioProps
}: Props) {
    const mudarMes = (meses: number) =>
        onCompetenciaChange(
            dayjs(competencia).add(meses, 'month').format('YYYY-MM'),
        )

    return (
        <div className="size-full flex-1 min-h-0 flex flex-col overflow-hidden">
            <GridToolbarContainer className="gap-4 flex-nowrap">
                <div className="flex items-center gap-4 min-w-0">
                    <ButtonGroup className="*:h-10 *:aspect-1/1 *:min-w-0 *:p-2">
                        <Button
                            onClick={() => mudarMes(-1)}
                            title="Mês anterior"
                            variant="outlined"
                        >
                            <ChevronLeftIcon />
                        </Button>
                        <Button
                            onClick={() => mudarMes(1)}
                            title="Próximo mês"
                            variant="outlined"
                        >
                            <ChevronRightIcon />
                        </Button>
                    </ButtonGroup>
                    <Label className="text-lg truncate select-none">
                        {dayjs(competencia)
                            .format('MMMM [de] YYYY')
                            .replace(/^[a-z]/, l => l.toUpperCase())}
                    </Label>
                </div>
                {acoes}
            </GridToolbarContainer>
            <div className="border rounded-b-md flex-1 min-h-0 flex flex-col overflow-hidden">
                {loading ? (
                    <Skeleton className="flex-1" />
                ) : (
                    <CalendarioMensal
                        competencia={competencia}
                        {...calendarioProps}
                    />
                )}
            </div>
        </div>
    )
}
